import Indicator, { IndicatorType } from '../types/Indicator'

const DonchianChannel: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'donchianChannel',
  label: 'Donchian Channel',
  nickname: 'Donchian Channel',
  fields: ['middle', 'upper', 'lower'],
  params: {
    highPeriod: 20,
    lowPeriod: 20,
  },
}

export default DonchianChannel
